import classNames from 'classnames';
import { Icon } from 'ui';
import PropTypes from 'prop-types';
import React from 'react';
import './ChatCheckbox.scss';

function ChatCheckbox({ checked = false, checkboxPosition = 'left', className = '', description = null, disabled = false, id, label = null, name, onChange }) {
  const checkboxId = id || `chat-checkbox-${Math.random().toString(36).substring(2, 11)}`;

  const checkboxClasses = classNames(
    'chat-checkbox',
    {
      'chat-checkbox--disabled': disabled,
      'chat-checkbox--position-right': checkboxPosition === 'right',
    },
    className
  );

  const handleChange = (e) => {
    if (!disabled && onChange) {
      onChange(e);
    }
  };

  return (
    <div className={checkboxClasses}>
      <label className="chat-checkbox__label" htmlFor={checkboxId}>
        <div className="chat-checkbox__input-wrapper">
          <input
            type="checkbox"
            id={checkboxId}
            name={name}
            className="chat-checkbox__input"
            checked={checked}
            onChange={handleChange}
            disabled={disabled}
            aria-describedby={description ? `${checkboxId}-description` : undefined}
          />
          <div className="chat-checkbox__custom">{checked && <Icon name="check" className="chat-checkbox__checkmark" color="white" />}</div>
        </div>
        <div className="chat-checkbox__content">
          {label && <span className="chat-checkbox__text">{label}</span>}
          {description && (
            <span id={`${checkboxId}-description`} className="chat-checkbox__description">
              {description}
            </span>
          )}
        </div>
      </label>
    </div>
  );
}

ChatCheckbox.propTypes = {
  checked: PropTypes.bool,
  checkboxPosition: PropTypes.oneOf(['left', 'right']),
  className: PropTypes.string,
  description: PropTypes.node,
  disabled: PropTypes.bool,
  id: PropTypes.string,
  label: PropTypes.node,
  name: PropTypes.string,
  onChange: PropTypes.func,
};

export default ChatCheckbox;
